import { render } from "./PageContent.vue?vue&type=template&id=eec95cda"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/PageContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eec95cda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eec95cda', __exports__)) {
    api.reload('eec95cda', __exports__)
  }
  
  module.hot.accept("./PageContent.vue?vue&type=template&id=eec95cda", () => {
    api.rerender('eec95cda', render)
  })

}


export default __exports__